export type PartialLodash = Pick<
  typeof import('lodash'),
  'debounce' | 'throttle'
>;
